<template>
  <div id="QuestionList">
    <div class="list notice" v-if="fixedQuestion">
      <Question :mode="'list'" :question="fixedQuestion[0]" :clamp="40" />
    </div>
    <div
      class="list post"
      v-for="(question, index) in questions"
      :key="index"
      :id="'Question-' + question.uuid"
    >
      <!--v-inview:animate="'fadeIn'"-->
      <Question
        :key="index"
        :mode="'list'"
        :isLast="index == questions.length"
        :question="question"
        v-if="question"
        @editQuestion="editQuestion"
        @removeQuestion="removeQuestion"
      />
    </div>
  </div>
</template>

<script>
// Apis Section
// import mixins from '@/api/now/mixins'

// Components Section
import Question from './Question'

// Variable Section
// let self

export default {
  name: 'QuestionList',
  props: ['questions', 'fixedQuestion'],
  components: {
    Question,
  },
  data: function () {
    return {}
  },
  computed: {},
  async created() {},
  destroyed() {},
  methods: {
    editQuestion(question) {
      this.$emit('editQuestion', question)
    },
    removeQuestion(question) {
      this.$emit('removeQuestion', question)
    },
  },
}
</script>

<style lang="scss" scoped>
#QuestionList {
  width: 100%;
  .list {
    width: 100%;

    &.post {
      .official-account {
        display: none;
      }
    }
  }
}
</style>
